import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { ToastService } from '@core/services/toast/toast.service';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';

@Component({
  selector: 'app-toast-outlet',
  imports: [MatIcon, MatIconButton],
  templateUrl: './toast-outlet.component.html',
  styleUrl: './toast-outlet.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastOutletComponent {
  readonly toast = inject(ToastService);

  readonly hasErrorNotifications = computed(() =>
    this.toast.notifications().some((n) => n.type === 'error'),
  );

  dismiss(id: string): void {
    this.toast.dismiss(id);
  }

  iconFor(type: 'success' | 'error' | 'warning' | 'info'): string {
    if (type === 'success') {
      return 'check_circle';
    }
    if (type === 'error') {
      return 'error';
    }
    if (type === 'warning') {
      return 'warning';
    }
    return 'info';
  }

  labelFor(type: 'success' | 'error' | 'warning' | 'info'): string {
    if (type === 'success') {
      return 'Success';
    }
    if (type === 'error') {
      return 'Error';
    }
    if (type === 'warning') {
      return 'Warning';
    }
    return 'Info';
  }
}
